// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2pdV6","resendInfoText":"OnGoingPaymentBox_resendInfoText__2KG6R"};